<template>
  <div class="tooth-svc-row">
    <div v-if="rowCount > 1" class="tooth-svc-row__head">
      <span class="badge badge-pill iq-bg-primary">{{ $t('Line') }} {{ rowIndex + 1 }}</span>
      <button type="button" class="btn btn-sm btn-link text-danger p-0" :title="$t('Delete')" :aria-label="$t('Delete')" @click="$emit('remove', row)">
        <i class="fa fa-times" aria-hidden="true"></i>
      </button>
    </div>

    <b-row>
      <b-form-group :class="showPricing ? 'col-md-6' : 'col-md-9'" :label="$t('ServiceOrProduct')">
        <v-select transition="" v-model="row.entityId"
                  :reduce="s => s.id" label="name"
                  :filterBy="$root.filterOptions"
                  :searchable="true"
                  :clearable="false"
                  :options="entityList"
                  @input="onEntitySelected">
          <template v-slot:option="option">
            <i :class="option.icon" class="mr-1"></i>{{ option.name }}
          </template>
          <template v-slot:no-options>
            {{ $t('NoMatchingOptionsMessage') }}
          </template>
        </v-select>
      </b-form-group>

      <b-form-group :class="showPricing ? 'col-md-2 col-6' : 'col-md-3'" :label="$t('Quantity')">
        <input v-model="row.quantity" type="text" class="form-control" inputmode="decimal" @keypress="$root.isNumber" @input="recalculate" />
      </b-form-group>

      <template v-if="showPricing">
        <b-form-group class="col-md-4 col-6" :label="$t('Discount')">
          <input v-model="row.userInputDiscount" type="text" class="form-control" placeholder="%10" @keypress="$root.isNumber" @input="recalculate" />
        </b-form-group>

        <b-form-group class="col-md-4 col-6" :label="$t('PriceWithCard')">
          <b-form-checkbox v-model="row.useCreditPrice" switch size="lg" class="pt-1" @change="recalculate" />
        </b-form-group>

        <b-form-group class="col-md-4 col-6" :label="$t('Rate')">
          <v-select transition="" v-model="row.currencyId"
                    :clearable="false"
                    :reduce="s => s.currencyId" label="symbol"
                    :options="currencyList"
                    @input="recalculate">
          </v-select>
        </b-form-group>

        <b-form-group class="col-md-4" :label="$t('Price')">
          <input v-model="row.rowTotal" type="text" class="form-control text-right" inputmode="decimal" @keypress="$root.isNumber" />
        </b-form-group>
      </template>
    </b-row>
  </div>
</template>

<script>
  import { calculateRowTotal } from './toothConfig'

  export default {
    name: 'ToothTreatmentServiceRow',
    props: {
      row: { type: Object, required: true },
      rowIndex: { type: Number, required: true },
      rowCount: { type: Number, required: true },
      entityList: { type: Array, default: () => [] },
      currencyList: { type: Array, default: () => [] },
      showPricing: { type: Boolean, default: true }
    },
    methods: {
      onEntitySelected(entityId) {
        const entity = this.entityList.find(e => e.id == entityId)
        if (!entity) return

        this.row.entity = entity
        // Liste fiyatı hizmetin kendi kurundadır; satırın kuru da ona eşitlenir.
        if (entity.currencyId) this.row.currencyId = entity.currencyId
        this.recalculate()

        this.$emit('entity-selected', { row: this.row, entity })
      },
      recalculate() {
        // v-model bu olaydan sonra güncellendiği için hesap bir sonraki tick'te yapılır.
        this.$nextTick(() => {
          if (this.row.quantity) this.row.quantity = this.row.quantity.toString().replace(',', '.')
          if (this.row.userInputDiscount && this.row.userInputDiscount !== '%')
            this.row.userInputDiscount = this.row.userInputDiscount.toString().replace(',', '.')
          this.row.rowTotal = calculateRowTotal(this.row)
        })
      }
    }
  }
</script>

<style scoped>
  .tooth-svc-row {
    padding: 12px 0 0;
    border-top: 1px solid #eef2f3;
  }

  .tooth-svc-row:first-child {
    border-top: 0;
    padding-top: 0;
  }

  .tooth-svc-row__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
  }

  .tooth-svc-row >>> .form-group {
    margin-bottom: 12px;
  }

  .tooth-svc-row >>> .col-form-label,
  .tooth-svc-row >>> legend {
    font-size: 13px;
    color: #777d74;
    padding-bottom: 4px;
  }
</style>
